import { Component } from '@angular/core';
import { IStatusPanelParams } from 'ag-grid-community';

@Component({
  selector: 'status-component',
  template: `<div class="valueCount grid">
  <span style="font-weight: bold; margin-left: 5px;"> Invalid Rows : </span> <span style="color: black;">{{params.context.componentParent.invalidCount}}</span>  
  <label for="chkSel" class="ml-3 mr-1"> Show Invalid Rows </label>
  <p-checkbox inputId="chkSel" (onChange)="params.context.componentParent.showInvalidRows($event)" [disabled]="params.context.componentParent.invalidCount === 0" [binary]="true" inputId="binary" size="large" />
  </div>`,
  styles: ['.valueCount { margin-left: 8px;margin-top: 8px; }'],
})
export class InvalidCountComponent {
  public params: IStatusPanelParams;

  agInit(params: IStatusPanelParams): void {
    this.params = params;
  }
}